import index from './pages/index/index.vue';
import mIndex from './pages/mIndex/mIndex.vue';
export default {
    routes: [
        {
            path: '/',
            component: index
        },
        {
            path: '/mIndex',
            component: mIndex
        }
    ]
};


// WEBPACK FOOTER //
// ./src/router.js